/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { forwardRef } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button/standard-button';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { AI_MODAL_SCREEN_CLASS } from '../../../utils/constants';
import { FloatingContainer } from '../../components/FloatingContainer/FloatingContainer';
import { buttonAutoFocusRingFix } from '../../styles/focus';
import messages from './messages';
import { buttonContainerStyles, getContainerStyles, getIconStyles, getTextContainerStyles, iconColor, textStyles } from './styles';
export function ErrorMessage(_ref) {
  var children = _ref.children,
    breakpoint = _ref.breakpoint;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return (
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    jsx("div", {
      css: getTextContainerStyles(breakpoint)
    }, jsx("span", {
      css: getIconStyles(breakpoint)
    }, jsx(WarningIcon, {
      label: formatMessage(messages.warningIconLabel),
      primaryColor: iconColor
    })), jsx("p", {
      css: textStyles
    }, children))
  );
}
export function ErrorButton(_ref2) {
  var children = _ref2.children,
    onClick = _ref2.onClick,
    appearance = _ref2.appearance,
    testId = _ref2.testId,
    autoFocus = _ref2.autoFocus,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled;
  return jsx(Button
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
  , {
    css: buttonAutoFocusRingFix,
    autoFocus: autoFocus,
    testId: testId,
    spacing: "compact",
    onClick: onClick,
    type: "button",
    appearance: appearance,
    isDisabled: disabled
  }, children);
}
export function ErrorButtonContainer(_ref3) {
  var children = _ref3.children;
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
  return jsx("div", {
    css: buttonContainerStyles
  }, children);
}

// Need to use forwardRef because functional component cannot be passed a ref
// as a prop.
export var ErrorFloatingContainer = /*#__PURE__*/forwardRef(function (_ref4, ref) {
  var children = _ref4.children,
    breakpoint = _ref4.breakpoint;
  return jsx(FloatingContainer, {
    ref: ref,
    "data-testid": "error-screen"
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ,
    className: "error-screen ".concat(AI_MODAL_SCREEN_CLASS)
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ,
    css: getContainerStyles(breakpoint),
    paddingAdjustments: {
      top: 1,
      bottom: 1
    },
    rainbowBorder: !editorExperiment('platform_editor_ai_command_palette_post_ga', 'test')
  }, children);
});